<div class="bulk-modal-backdrop" (click)="handleCancel()"></div>

<div class="bulk-modal" role="dialog" aria-modal="true" aria-labelledby="bulkTitle">
  <div class="close-button" (click)="handleCancel()" aria-label="Cerrar">
    X
  </div>
  <div class="bulk-header">
    <div class="titles">
      <h3 id="bulkTitle">{{ bulkUploadModalContet()?.title }}</h3>
    </div>
  </div>

  <!-- Barra de progreso y etiquetas de pasos -->
  <div class="bulk-steps">
    <div class="steps-track">
      <div class="step-bar" [class.active]="step === 1"></div>
      <div class="step-bar" [class.active]="step === 2"></div>
    </div>
    <div class="steps-labels">
  <span [class.active-text]="step === 1" [class.disabled-text]="step !== 1">
    {{ bulkUploadModalContet()?.firstStepTitle }}
  </span>
      <span [class.active-text]="step === 2" [class.disabled-text]="step !== 2">
    {{ bulkUploadModalContet()?.secondStepTitle }}
  </span>
    </div>

  </div>

  <div class="bulk-body">
    <!-- PASO 1: Obtener formato -->
    @if (step === 1) {
      <div class="step-one two-col">
        <!-- Izquierda: icono-botón de descarga -->
        <button
          type="button"
          class="download-icon-btn"
          (click)="descargarPlantilla()"
          aria-label="Descargar formato de carga masiva"
          title="Descargar formato de carga masiva">
          <div [innerHTML]="sanitizer.bypassSecurityTrustHtml(AppIcons.DESCARGA_FORMATO)"></div>
        </button>

        <!-- Derecha: textos -->
        <div class="download-copy">
          <p class="lead">
            <strong>Descarga el formato de carga masiva</strong><br/>
            con la información de los empleados, modifícalo y ve al siguiente paso.
          </p>
        </div>
      </div>
    }


    <!-- PASO 2: Subir modificaciones  -->
    @if (step === 2) {
      <div class="step-two">
        <p class="hint">
          Sube un archivo <strong>.xlsx</strong> o <strong>.csv</strong> con los encabezados recomendados.
          Tamaño máximo: {{ maxFileSizeMb }} MB.
        </p>

        <div class="dropzone"
             [class.dragging]="isDragging"
             (drop)="onDrop($event)"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave()">

          @if (!file) {
            <div class="drop-inner">
              <p>{{ bulkUploadModalContet()?.dragAndDropLabel }}</p>
              <span>o</span>
              <label class="upload-btn">
                Seleccionar archivo
                <input type="file"
                       [attr.accept]="accept"
                       (change)="onFileSelected($event)"
                       hidden>
              </label>
            </div>
          } @else {
            <div class="file-chip">
              <div class="file-info">
                <strong>{{ file.name }}</strong>
                <small>{{ (file.size / 1024 / 1024) | number:'1.2-2' }} MB</small>
              </div>
              <button class="icon-btn" title="Quitar" (click)="removeFile()">✕</button>
            </div>
          }
        </div>

        @if (errorMsg) {
          <div class="error">{{ errorMsg }}</div>
        }
      </div>
    }

  </div>

  <div class="bulk-footer">
    <button class="btn ghost" (click)="onBack()">{{ bulkUploadModalContet()?.backButton }}</button>

    @if (step === 1) {
      <button class="btn primary" (click)="step = 2">{{ bulkUploadModalContet()?.nextButton }}</button>
    }
    @if (step === 2) {
      <button class="btn primary" [disabled]="!file || !!errorMsg" (click)="handleConfirm()">Continuar</button>
    }
  </div>

</div>
